import React, { useState, useRef, useEffect } from "react";
import Header from "./Header";
import sign_up from "../assets/images/sign_up.png";
 
function DeleteUser() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [isPhoneNumberEntered, setIsPhoneNumberEntered] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const alertRef = useRef<HTMLDivElement>(null);
 
  const handlePhoneInputChange = (e: { target: { value: any } }) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) {
      setError("Phone number must contain only numbers.");
      return;
    }
    setPhoneNumber(value);
    setError("");
  };
 
  const handleOtpInputChange = (e: { target: { value: any } }) => {
    const value = e.target.value;
    if (value.length > 6) {
      setError("OTP must be exactly 6 digits.");
      return;
    }
    if (!/^\d*$/.test(value)) {
      setError("OTP must contain only numbers.");
      return;
    }
    setOtp(value);
    setError("");
  };
 
  const handleGenerateOTP = () => {
    if (phoneNumber.length !== 10) {
      setError("Phone number must be exactly 10 digits.");
      return;
    }
    // Logic to generate OTP
    console.log("Generating OTP for phone number:", phoneNumber);
    setIsPhoneNumberEntered(true);
  };
 
  const handleConfirmOTP = () => {
    if (otp.length !== 6) {
      setError("OTP must be exactly 6 digits.");
      return;
    }
    // Logic to confirm OTP and delete data
    console.log("Confirming OTP:", otp);
    // Add your logic to delete the user data here
    setIsAlertVisible(true);
  };
 
  const closeModalAlert = () => {
    setIsAlertVisible(false);
  };
 
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (alertRef.current && !alertRef.current.contains(event.target as Node)) {
        closeModalAlert();
      }
    };
 
    if (isAlertVisible) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
 
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isAlertVisible]);
 
  useEffect(() => {
    if (!isAlertVisible) {
      // Reset the state to initial values
      setPhoneNumber("");
      setOtp("");
      setError("");
      setIsPhoneNumberEntered(false);
    }
  }, [isAlertVisible]);
 
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-50">
      <div className="flex flex-row shadow-xl rounded-2xl h-[550px]">
        <div className="">
          <img
            src={sign_up}
            alt="Description"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex w-64 flex-col bg items-center ml-5 mr-5 justify-center">
          <h1 className="text-3xl mb-4 font-bold text-gray-800">Delete User</h1>
          {!isPhoneNumberEntered ? (
            <>
              <input
                type="text"
                value={phoneNumber}
                onChange={handlePhoneInputChange}
                placeholder="Enter 10-digit phone number"
                className="p-2 mb-4 border border-gray-300 rounded-md"
                maxLength={10}
              />
              {error && <p className="text-red-500 mb-4">{error}</p>}
              <button
                onClick={handleGenerateOTP}
                className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
              >
                Generate OTP
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                value={otp}
                onChange={handleOtpInputChange}
                placeholder="Enter 6-digit OTP"
                className="p-2 mb-4 border border-gray-300 rounded-md"
                maxLength={6}
              />
              {error && <p className="text-red-500 mb-4">{error}</p>}
              <button
                onClick={handleConfirmOTP}
                className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
              >
                Confirm OTP to Delete Data
              </button>
            </>
          )}
        </div>
      </div>
      {isAlertVisible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div
            className="bg-white w-full max-w-md p-8 pt-14 pb-14 rounded-lg shadow-lg relative"
            ref={alertRef}
          >
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
              onClick={closeModalAlert}
            >
              ✖
            </button>
            <h2 className="text-2xl font-bold text-pink-600 text-center">
              Data Deleted Successfully!
            </h2>
            <p className="text-center mt-4 text-gray-700">
              Your data has been deleted successfully.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
 
export default DeleteUser;
 